export type FormaPagamentoFiscal = {
    id: number
    descricao: string
    selecionada: boolean
}

export type ConfiguracaoFiscalModel = {
    emissaoAutomatica: boolean
    cnpjPlugNotas: string
    tipoEmissao: string
    limiteDiario: string
    emailsFechamentoFiscal: string
    regimeTributario: string
    cfopProducaoPropria: string
    cfopRevenda: string
    csosnProducaoPropria: string
    csosnRevenda: string
    emissoesHoje: number
    valorEmitidoHoje: number
    formas: FormaPagamentoFiscal[]
}

export const ConfiguracaoFiscalInicial: ConfiguracaoFiscalModel = {
    emissaoAutomatica: false,
    cnpjPlugNotas: "",
    tipoEmissao: "EMISSAO_COM_IMPRESSAO",
    limiteDiario: "",
    emailsFechamentoFiscal: "",
    regimeTributario: "SIMPLES",
    cfopProducaoPropria: "5101",
    cfopRevenda: "5405",
    csosnProducaoPropria: "102",
    csosnRevenda: "500",
    emissoesHoje: 0,
    valorEmitidoHoje: 0,
    formas: [],
}
